/* eslint-disable */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { getRoomsfilter } from '@/app/services/CompanyReports/companyReports';
import { getEmergencyContacts, getSchools } from '@/app/services/reports/reports';
import * as Actions from '@/app/store/actions';
import { generateAgeString } from '@/utils/utils';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	Avatar,
	CircularProgress,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import './companyReport.css';
import ProfileInfoCard from './ProfileInfoCard';
import { useNavigate } from 'react-router-dom';

export default function EmergencyContact() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const user = useSelector(({ auth }) => auth.user);
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [iisLoading, ssetIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const checkInReportRef = useRef(null);
	const [page, setPage] = useState(1);
	const [filters, setFilters] = useState({
		school_id: '',
		room_id: '',
		status: '',
		contact_type: '',
	});

	const [schools, setSchool] = useState([]);
	const [rooms, setRooms] = useState([]);
	const [contact, setContact] = useState('');
	const [date, setDate] = useState(new Date());
	const [roomPage, setRoomPage] = useState(1);
	const [searchQuery, setSearchQuery] = useState('');

	const handleSearch = (e) => {
		setSearchQuery(e.target.value);
	};

	const handlePrint = useReactToPrint({
		content: () => checkInReportRef.current,
	});

	useEffect(() => {
		let isMounted = true;
		getRoomsfilter(roomPage, filters?.school_id == 'All' ? '' : filters?.school_id)
			.then((res) => {
				if (!isMounted) return;
				setRooms([...rooms, ...res.data.data]);
				if (res.data.current_page < res.data.last_page) {
					setRoomPage(roomPage + 1);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get rooms.',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
			});
		return () => {
			isMounted = false;
		};
	}, [roomPage, filters?.school_id, dispatch]);

	const ApplyFilters = () => {
		setRows([]);
		setIsLoading(true);
		setFirstLoad(false);
		const timeout = setTimeout(
			() => {
				getEmergencyContacts(filters, 1, searchQuery)
					.then((res) => {
						setFirstLoad(false);
						setRows(res.data.data);
						if (res.data.last_page > res.data.current_page) {
							setHasMore(true);
						} else {
							setHasMore(false);
						}
						setPage(res.data.current_page + 1);
						setContact(filters?.contact_type);
						dispatch(
							Actions.showMessage({
								message: 'Report has been generated',
								variant: 'success',
							}),
						);
						// setPage(res.data.current_page + 1);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to fetch data, please refresh',
								variant: 'error',
							}),
						);
					})
					.finally(() => {
						setIsLoading(false);
					});
			},
			firstLoad ? 0 : 1000,
		);
		setPage(1);
		return () => {
			clearTimeout(timeout);
		};
	};

	const handleLoadMore = () => {
		setFetchingMore(true);
		getEmergencyContacts(filters, page, searchQuery)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setFetchingMore(false);
			})
			.catch((err) => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			});
	};

	const handleFilters = (ev) => {
		const { name, value } = ev.target;
		if (name === 'school_id') {
			setRooms([]);
			setRoomPage(1);
		}
		setFilters({ ...filters, [name]: value });
	};

	useEffect(() => {
		let isMounted = true;
		getSchools().then((res) => {
			if (!isMounted) return;
			console.log(res?.data?.data);
			setSchool(res?.data?.data);
		});
		return () => {
			isMounted = false;
		};
	}, []);

	const handleExport = () => {
		ssetIsLoading(true);
		getEmergencyContacts(filters, 1, searchQuery, 1)
			.then((res) => {
				const blob = new Blob([res.data], {
					type: 'text/csv',
				});
				const link = document.createElement('a');
				link.setAttribute('target', '_blank');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', `Emergency_contact_report_${new Date().getTime()}.csv`);
				document.body.appendChild(link);
				link.click();
				// Clean up and remove the link
				link.parentNode.removeChild(link);
				ssetIsLoading(false);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Export',
						variant: 'error',
					}),
				);
				ssetIsLoading(false);
			})
			.finally(() => {
				ssetIsLoading(false);
			});
	};

	const handleProfileCard = (row, self) => {
		dispatch(
			Actions.openDialog({
				// TODO: replace this with the new profile modal when we get in here for responsiveness reasons
				children: <ProfileInfoCard row={row} self={self} />,
			}),
		);
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="mx-auto allergy-cont">
				<div className="flex items-center flex-nowrap justify-between">
					<div className="reports-topDiv">
						<h1 className="">
							{' '}
							<span className="icon-color">
								<IconButton
									onClick={() => {
										navigate('/company-reports');
									}}
								>
									<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
								</IconButton>
							</span>
							<span className="text-pd-xl self-end font-bold mr-28">Emergency Contacts</span>
						</h1>
						<p>Detail data of emergency contacts information </p>
					</div>
					<div className="flex justify-between">
						<div className="flex">
							<div className="self-end btn-aller">
								<span>
									{!iisLoading ? (
										<a>
											<CustomButton
												height="40px"
												marginRight="17px"
												onClick={handleExport}
												variant="primary"
												width="100px"
											>
												<span className="mr-4">
													<FontAwesomeIcon icon={faDownload} />
												</span>
												Export
											</CustomButton>
										</a>
									) : (
										<div className="circle-bar">
											<CircularProgress size={35} />
										</div>
									)}
									<CustomButton height="40px" onClick={() => handlePrint()} variant="secondary" width="100px">
										<i aria-hidden="true" className="fa fa-print" /> Print
									</CustomButton>
									{/* <div className="help-btn cursor-pointer">
										<img src="assets/images/CENTER.png" />
										Help Center
									</div> */}
								</span>
							</div>
						</div>
					</div>
				</div>

				<div className="flex items-center flex-nowrap justify-between">
					<span className="text-pd-2xl self-end font-extrabold mr-28" />
					<div className="flex justify-between">
						<div className="flex">
							<div className="mx-8">
								<TextField
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													id="search-icon"
													onClick={() => {
														document.getElementById('search-input').focus();
													}}
												>
													<img alt="search-icon" height="80%" src="assets/images/search-icon.svg" width="80%" />
												</IconButton>
											</InputAdornment>
										),
									}}
									className="mr-10"
									id="search-input"
									label="Search by Student"
									onChange={handleSearch}
									style={{ width: 170 }}
									value={searchQuery}
								/>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="schoolLabel">School</InputLabel>
									<Select
										endAdornment={
											filters?.school_id ? (
												<IconButton className="mr-16" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																school_id: '',
															});
															setRooms([]);
															setRoomPage(1);
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										label="School"
										labelId="schoolLabel"
										name="school_id"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.school_id}
									>
										<MenuItem value="All">All</MenuItem>
										{schools?.length ? (
											schools?.map((school) => {
												return (
													<MenuItem id={school?.id} key={school?.id} value={school?.id}>
														<div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{school?.name}</div>
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="room_id">Room</InputLabel>
									<Select
										endAdornment={
											filters.room_id ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																room_id: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="room_id"
										label="Room"
										labelId="roomLabel"
										name="room_id"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.room_id}
									>
										<MenuItem value="All">All</MenuItem>
										{rooms.length ? (
											rooms.map((room) => {
												return (
													<MenuItem id={room.id} key={room.id} value={room.id}>
														{room.name}
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="contactType">Contact Type</InputLabel>
									<Select
										endAdornment={
											filters.contact_type ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																contact_type: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="contact_type"
										label="Type of contact"
										labelId="contact_type"
										name="contact_type"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.contact_type}
									>
										<MenuItem value="parent">Parent</MenuItem>
										<MenuItem value="legal_guardian">Legal Guardian</MenuItem>
										<MenuItem value="extended_family">Family</MenuItem>
										<MenuItem value="approved">Approved Pickup</MenuItem>
									</Select>
								</FormControl>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="status">Status</InputLabel>
									<Select
										endAdornment={
											filters.status ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																status: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="status"
										label="status"
										labelId="status"
										name="status"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.status}
									>
										<MenuItem value="1">Active</MenuItem>
										<MenuItem value="0">Inactive</MenuItem>
									</Select>
								</FormControl>
							</div>
						</div>

						<div className="self-end">
							<span>
								<span className="mx-4">
									<CustomButton
										disabled={
											!filters.status && !filters.room_id && !filters.school_id && !searchQuery
												? !filters.contact_type
												: null
										}
										fontSize="15px"
										height="43"
										onClick={() => {
											ApplyFilters();
										}}
										variant="secondary"
										width="140px"
									>
										Apply
									</CustomButton>
								</span>
							</span>
						</div>
					</div>
				</div>

				{/* table  */}
				<TableContainer className="allergy-table-cont" component={Paper} id="Scrollable-table">
					<div style={{ display: 'none' }}>
						<div className="p-32" ref={checkInReportRef}>
							<div className="flex flex-row justify-between">
								<div>
									<img alt="" src="assets/images/logos/logo.png" />
								</div>
								<div style={{ textAlign: 'right' }}>
									<Typography variant="subtitle1">
										<span style={{ display: 'block', marginBottom: '-0.7em', writingMode: '' }}>
											{user?.data?.school?.address}
										</span>{' '}
										{/* <span>Hom Lake, Orlando, FL 38637</span> */}
									</Typography>
									<Typography variant="subtitle1">{user?.data?.phone}</Typography>
									<Typography variant="subtitle1">{user?.data?.email}</Typography>
								</div>
							</div>
							<div style={{ marginBottom: '20px' }}>
								<span>
									<strong>Date: </strong>
								</span>
								<span>{moment(date).format('dddd, DD MMMM YYYY')}</span>
							</div>
							<div className="pdf-heading">
								<h1 className="font-extrabold">Emergency Contact</h1>
							</div>

							<Table className="student-table" stickyHeader style={{ width: '100%' }}>
								<TableHead>
									<TableRow>
										<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
											Student
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '40%' }}>
											Emergency Contacts
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '24%' }}>
											School Name
										</TableCell>
										{/* <TableCell style={{ width: '25%' }} className="bg-white studentTableHeader">
											Contact Info
										</TableCell> */}
										<TableCell className="bg-white studentTableHeader" style={{ width: '22%' }}>
											Address
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody className="">
									{isLoading ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												<CircularProgress size={35} />
											</TableCell>
										</TableRow>
									) : !rows.length && !firstLoad ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												No record found
											</TableCell>
										</TableRow>
									) : (
										rows?.map((row) => {
											return (
												<TableRow key={row.id}>
													<TableCell
														className="bg-white"
														style={{
															fontSize: '13px',
															// maxWidth: '100px',
															fontWeight: 'bold',
															// overflow: 'hidden',
															// textOverflow: 'ellipsis',
															// whiteSpace: 'nowrap'
														}}
													>
														<div
															className="flex cursor-pointer"
															// onClick={() => goTostudentInformation(row)}
														>
															<Avatar className="mr-6" src={row?.thumb} />
															<div className="flex flex-col items-start">
																<div className="allergy-homeroom  break-word">{row?.home_room?.name}</div>
																<div className="report-staff  break-word">{row?.full_name}</div>
																<div className="font-normal  student-age-font" style={{ width: '90px' }}>
																	{generateAgeString(row.date_of_birth)}
																</div>
															</div>
														</div>
													</TableCell>
													<TableCell style={{ fontWeight: 700 }}>
														<div className="grid grid-cols-2 auto-col-min auto-row-min gap-y-10">
															{contact == 'parent' ? (
																<>
																	{row?.contacts

																		?.filter(
																			(val) =>
																				val?.emergency_contact &&
																				val?.role == 'parent' &&
																				val.school_id === row.school_id,
																		)
																		.map((parent, index) => (
																			<div
																				className="flex items-center cursor-pointer"
																				key={index}
																				onClick={() => handleProfileCard(row, parent)}
																			>
																				<Avatar
																					className="mr-4"
																					src={parent?.thumb}
																				/>
																				<div className="flex flex-col items-center">
																					<div className="emergency-parent-name  break-word">
																						{parent?.first_name} {parent?.last_name}
																					</div>
																					<div className="emergency-parent-relation self-start truncate">
																						{parent?.relation_with_child}
																					</div>
																				</div>
																			</div>
																		))}
																</>
															) : contact == 'approved' ? (
																<>
																	{row?.contacts
																		?.filter(
																			(val) =>
																				val?.emergency_contact &&
																				val?.role == 'approved_pickups' &&
																				val.school_id === row.school_id,
																		)
																		.map((parent, index) => (
																			<div
																				className="flex items-center cursor-pointer"
																				key={index}
																				onClick={() => handleProfileCard(row, parent)}
																			>
																				<Avatar
																					className="mr-4"
																					src={parent?.thumb}
																				/>
																				<div className="flex flex-col items-center">
																					<div className="emergency-parent-name  break-word">
																						{parent?.first_name} {parent?.last_name}
																					</div>
																					<div className="emergency-parent-relation self-start truncate">
																						{parent?.relation_with_child}
																					</div>
																				</div>
																			</div>
																		))}
																</>
															) : contact == 'extended_family' ? (
																<>
																	{row?.contacts
																		?.filter(
																			(val) =>
																				val?.emergency_contact &&
																				val?.role == 'extended_family' &&
																				val.school_id === row.school_id,
																		)
																		.map((parent, index) => (
																			<div
																				className="flex items-center cursor-pointer"
																				key={index}
																				onClick={() => handleProfileCard(row, parent)}
																			>
																				<Avatar
																					className="mr-4"
																					src={parent?.thumb}
																				/>
																				<div className="flex flex-col items-center">
																					<div className="emergency-parent-name truncate break-word">
																						{parent?.first_name} {parent?.last_name}
																					</div>
																					<div className="emergency-parent-relation self-start truncate">
																						{parent?.relation_with_child}
																					</div>
																				</div>
																			</div>
																		))}
																</>
															) : contact == 'legal_guardian' ? (
																<>
																	{row?.contacts
																		?.filter(
																			(val) =>
																				val?.emergency_contact &&
																				val?.relation_with_child == 'Legal Guardian' &&
																				val.school_id === row.school_id,
																		)
																		.map((parent, index) => (
																			<div
																				className="flex items-center cursor-pointer"
																				key={index}
																				onClick={() => handleProfileCard(row, parent)}
																			>
																				<Avatar
																					className="mr-4"
																					src={parent?.thumb}
																				/>
																				<div className="flex flex-col items-center">
																					<div className="emergency-parent-name  break-word">
																						{parent?.first_name} {parent?.last_name}
																					</div>
																					<div className="emergency-parent-relation self-start truncate">
																						{parent?.relation_with_child}
																					</div>
																				</div>
																			</div>
																		))}
																</>
															) : (
																<>
																	{row?.contacts
																		// .concat(row?.approved_pickups)
																		?.filter((val) => val?.emergency_contact && val.school_id === row.school_id)
																		.map((parent, index) => (
																			<div
																				className="flex items-center cursor-pointer"
																				key={index}
																				onClick={() => handleProfileCard(row, parent)}
																			>
																				<Avatar
																					className="mr-4"
																					src={parent?.thumb}
																				/>
																				<div className="flex flex-col items-center">
																					<div className="emergency-parent-name  break-word">
																						{parent?.first_name} {parent?.last_name}
																					</div>
																					<div className="emergency-parent-relation self-start truncate">
																						{parent?.relation_with_child}
																					</div>
																				</div>
																			</div>
																		))}
																</>
															)}
														</div>
													</TableCell>
													<TableCell
														className="bg-white "
														style={{
															fontSize: '13px',
															// maxWidth: '100px',
															fontWeight: 'bold',
															// overflow: 'hidden',
															// textOverflow: 'ellipsis',
															// whiteSpace: 'nowrap'
														}}
													>
														<div className="report-staff">{row?.school?.name}</div>
													</TableCell>

													<TableCell
														className="bg-white "
														style={{
															fontSize: '13px',
															// maxWidth: '100px',
															fontWeight: 'bold',
															// overflow: 'hidden',
															// textOverflow: 'ellipsis',
															// whiteSpace: 'nowrap'
														}}
													>
														<div className="report-staff">{row?.address1}</div>
													</TableCell>
												</TableRow>
											);
										})
									)}
								</TableBody>
							</Table>
						</div>
					</div>
					<Table className="student-table" stickyHeader style={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
									Student
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '32%' }}>
									Emergency Contacts
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '25%' }}>
									School Name
								</TableCell>
								{/* <TableCell style={{ width: '25%' }} className="bg-white studentTableHeader">
									Contact Info
								</TableCell> */}
								<TableCell className="bg-white studentTableHeader" style={{ width: '25%' }}>
									Address
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody className="">
							{firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										Generate your report
									</TableCell>
								</TableRow>
							) : isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows.length && !isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No record found
									</TableCell>
								</TableRow>
							) : (
								rows?.map((row) => {
									return (
										<TableRow key={row.id}>
											<TableCell
												className="bg-white truncate"
												style={{
													fontSize: '13px',
													maxWidth: '100px',
													fontWeight: 'bold',
													overflow: 'hidden',
													textOverflow: 'ellipsis',
													whiteSpace: 'nowrap',
												}}
											>
												<div
													className="flex cursor-pointer"
													// onClick={() => goTostudentInformation(row)}
												>
													<Avatar className="mr-6" src={row?.thumb} />
													<div className="flex flex-col items-start">
														<div className="allergy-homeroom truncate break-word">{row?.home_room?.name}</div>
														<div className="report-staff truncate break-word">{row?.full_name}</div>
														<div className="font-normal  student-age-font" style={{ width: '90px' }}>
															{generateAgeString(row?.date_of_birth)}
														</div>
													</div>
												</div>
											</TableCell>
											<TableCell style={{ fontWeight: 700 }}>
												<div className="grid grid-cols-2 auto-col-min auto-row-min gap-y-10">
													{contact == 'parent' ? (
														<>
															{row?.contacts

																?.filter(
																	(val) =>
																		val?.emergency_contact && val?.role == 'parent' && val.school_id === row.school_id,
																)
																.map((parent, index) => (
																	<div
																		className="flex items-center cursor-pointer"
																		key={index}
																		onClick={() => handleProfileCard(row, parent)}
																	>
																		<Avatar className="mr-4" src={parent?.thumb} />
																		<div className="flex flex-col items-center">
																			<div className="emergency-parent-name truncate break-word">
																				{parent?.first_name} {parent?.last_name}
																			</div>
																			<div className="emergency-parent-relation self-start truncate">
																				{parent?.relation_with_child}
																			</div>
																		</div>
																	</div>
																))}
														</>
													) : contact == 'approved' ? (
														<>
															{row?.contacts
																?.filter(
																	(val) =>
																		val?.emergency_contact &&
																		val?.role == 'approved_pickups' &&
																		val.school_id === row.school_id,
																)
																.map((parent, index) => (
																	<div
																		className="flex items-center cursor-pointer"
																		key={index}
																		onClick={() => handleProfileCard(row, parent)}
																	>
																		<Avatar className="mr-4" src={parent?.thumb} />
																		<div className="flex flex-col items-center">
																			<div className="emergency-parent-name truncate break-word">
																				{parent?.first_name} {parent?.last_name}
																			</div>
																			<div className="emergency-parent-relation self-start truncate">
																				{parent?.relation_with_child}
																			</div>
																		</div>
																	</div>
																))}
														</>
													) : contact == 'extended_family' ? (
														<>
															{row?.contacts
																?.filter(
																	(val) =>
																		val?.emergency_contact &&
																		val?.role == 'extended_family' &&
																		val.school_id === row.school_id,
																)
																.map((parent, index) => (
																	<div
																		className="flex items-center cursor-pointer"
																		key={index}
																		onClick={() => handleProfileCard(row, parent)}
																	>
																		<Avatar className="mr-4" src={parent?.thumb} />
																		<div className="flex flex-col items-center">
																			<div className="emergency-parent-name truncate break-word">
																				{parent?.first_name} {parent?.last_name}
																			</div>
																			<div className="emergency-parent-relation self-start truncate">
																				{parent?.relation_with_child}
																			</div>
																		</div>
																	</div>
																))}
														</>
													) : contact == 'legal_guardian' ? (
														<>
															{row?.contacts
																?.filter(
																	(val) =>
																		val?.emergency_contact &&
																		val?.relation_with_child == 'Legal Guardian' &&
																		val.school_id === row.school_id,
																)
																.map((parent, index) => (
																	<div
																		className="flex items-center cursor-pointer"
																		key={index}
																		onClick={() => handleProfileCard(row, parent)}
																	>
																		<Avatar className="mr-4" src={parent?.thumb} />
																		<div className="flex flex-col items-center">
																			<div className="emergency-parent-name truncate break-word">
																				{parent?.first_name} {parent?.last_name}
																			</div>
																			<div className="emergency-parent-relation self-start truncate">
																				{parent?.relation_with_child}
																			</div>
																		</div>
																	</div>
																))}
														</>
													) : (
														<>
															{row?.contacts
																?.filter((val) => val?.emergency_contact && val.school_id === row.school_id)
																.map((parent, index) => (
																	<div
																		className="flex items-center cursor-pointer"
																		key={index}
																		onClick={() => handleProfileCard(row, parent)}
																	>
																		<Avatar className="mr-4" src={parent?.thumb} />
																		<div className="flex flex-col items-center">
																			<div className="emergency-parent-name truncate break-word">
																				{parent?.first_name} {parent?.last_name}
																			</div>
																			<div className="emergency-parent-relation self-start truncate">
																				{parent?.relation_with_child}
																			</div>
																		</div>
																	</div>
																))}
														</>
													)}
												</div>
											</TableCell>
											<TableCell className="bg-white break-word">
												<div className="report-staff">{row?.school?.name}</div>
											</TableCell>

											<TableCell className="bg-white break-word">
												<div className="report-staff">{row?.address1}</div>
											</TableCell>
										</TableRow>
									);
								})
							)}
							{fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : (
								<></>
							)}
						</TableBody>
					</Table>
				</TableContainer>
				<InfiniteScroll
					dataLength={rows?.length}
					hasMore={hasMore}
					next={handleLoadMore}
					scrollableTarget="Scrollable-table"
				/>
			</div>
		</FuseAnimate>
	);
}
